import { render, staticRenderFns } from "./NoticeListItem.vue?vue&type=template&id=55a42141&scoped=true&"
import script from "./NoticeListItem.vue?vue&type=script&lang=js&"
export * from "./NoticeListItem.vue?vue&type=script&lang=js&"
import style0 from "styles/views/notice/noticelistitem.css?vue&type=style&index=0&id=55a42141&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a42141",
  null
  
)

export default component.exports